export type MealSlot = {
  name: string;
  recipe: RecipeData | null;
};

export type RecipeData = {
  id: string;
  title: string;
  meal: 'breakfast' | 'lunch' | 'snack' | 'dinner';
  calories: number;
  protein: number;
  ingredients: Ingredient[];
  instructions?: string;
  link?: string;
};

export type Ingredient = {
  name: string;
  quantity: string;
  unit: string;
  calories?: number;
  protein?: number;
};

export type GroceryItem = {
  name: string;
  totalQuantity: number;
  unit: string;
  meals: string[];
};

export const initialMealSlots: MealSlot[] = [
  { name: "Breakfast", recipe: null },
  { name: "Snack", recipe: null },
  { name: "Lunch", recipe: null },
  { name: "Snack", recipe: null },
  { name: "Dinner", recipe: null },
];